export default "__VITE_ASSET__BduG5Ggl__"